import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HomeBase } from '../routes/mars/models/home-base';
import { Classification } from '../routes/mars/models/classification';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {
  documentClicked: Subject<HTMLElement> = new Subject<HTMLElement>();

  constructor(private httpClient: HttpClient) {}

  getMarsHomeBases(): Observable<HomeBase[]> {
    return this.httpClient.get<HomeBase[]>(`${environment.API_URL}/mars/dropdown/homebase`);
  }

  getMadbHomeBases(): Observable<any> {
    return this.httpClient.get<any>(`${environment.API_URL}/base/dropdown/main`);
  }

  getSpikeBases(baseCode: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.API_URL}/base?type=spike&baseCode=${baseCode}`);
  }

  getBaseById(baseId: number): Observable<any> {
    return this.httpClient.get<any>(`${environment.API_URL}/base/${baseId}`);
  }

  getClassifications(): Observable<Classification[]> {
    return this.httpClient.get<Classification[]>(
      `${environment.API_URL}/mars/classificationandcategorydata`
    );
  }

  getMalfunctionTypes(): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/mars/malfunctiontypedata`);
  }

  getAreas(): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/area`);
  }

  getAircrafts(): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/travelmodes`);
  }

  getAllJumpers(): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/jumpers`);
  }

  getJumpers(baseId: number): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/jumpers?baseId=${baseId}`);
  }

  getJumperById(id: number, asOfDate?: string) {
    return this.httpClient.get(`${environment.API_URL}/jumpers/${id}${asOfDate ? `?asOfDate=${asOfDate}` : ''}`);
  }

  getQuals(): Observable<any> {
    return this.httpClient.get<any>(`${environment.API_URL}/quals`);
  }

  getMainParachutes(): Observable<any> {
    return this.httpClient.get<any>(`${environment.API_URL}/chutemain?limit=100000`);
  }

  getDrogueParachutes(): Observable<any> {
    return this.httpClient.get<any>(`${environment.API_URL}/chutedrogue?limit=100000`);
  }

  getReserveParachutes(): Observable<any> {
    return this.httpClient.get<any>(`${environment.API_URL}/chutereserve?limit=100000`);
  }

  getManufacturers(): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/mars/dropdown/chutemanufacturer`);
  }

  getDashboardStats(): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/mars/appsupport/getdashboardstats`);
  }
}
